/**
 * @voltxampere/ui — 2N3819 n-channel JFET variant (Sprint 38-3)
 *
 * Reference: Vishay 2N3819 datasheet (TO-92 RF amplifier JFET).
 *   Vt0   = -3.0 V         (pinch-off voltage V_P, datasheet -0.5..-7.5 V)
 *   Beta  = 2.67e-3 A/V²   (= 2·IDSS/Vp² for IDSS ≈ 12 mA, |Vp| = 3)
 *   Lambda = 0.005 1/V     (low channel-length modulation)
 *
 * Engine zero-diff invariant honored — variant maps to canonical
 * `jfet-n` engine stamp (Sprint 23).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { jfet } from "../jfet.js";
export const jfetN2n3819 = {
    id: "2n3819",
    nameTr: "2N3819 (JFET n-kanal, TO92)",
    nameEn: "2N3819 (n-channel JFET, TO92)",
    shortcut: "J",
    category: "active",
    viewBox: jfet.viewBox,
    terminals: jfet.terminals,
    defaultLabel: "J",
    defaultValue: "2N3819",
    schemaType: "jfet-n",
    defaultParams: { Vt0: -3.0, Beta: 2.67e-3, Lambda: 0.005 },
    renderSVG: () => jfet.renderSVG(),
};
//# sourceMappingURL=jfet-n-2n3819.js.map